import Jasypt from 'jasypt'
import LOG from '../../logging/Logger'
import SimpleCache from '../Cache'
import { createEncryptor } from 'simple-encryptor'

export default class Encrytpter {
  constructor(password) {
    this.jasypt = new Jasypt()
    this.simpleEncrypter = null

    this.encryptCache = new SimpleCache()
    this.decryptCache = new SimpleCache()
  }

  setPassword(password) {
    this.jasypt.setPassword(password)
    this.simpleEncrypter = createEncryptor(password)
  }

  encrypt(str) {
    return this.encryptCache.lookupKey(str, () =>
    this.simpleEncrypter ? this.simpleEncrypter.encrypt(str) : str
    )
  }

  decrypt(str) {
    if (str) {
      return this.decryptCache.lookupKey(str, () => {
        try {
          const decrypted = this.simpleEncrypter?.decrypt(str)
          if (decrypted) {
            return decrypted
          }
          throw new Error('Unexpected encryption')
        } catch (cerror) {
          LOG.debug('Not encrypted using new encryption, try legacy', cerror)
          try {
            return this.jasypt.decrypt(str)
          } catch (jerror) {
            LOG.warn('Not encrypted using old encryption', jerror)
          }
        }
        return this.decryptCache.lookupKey(str, () => str)
      })
    }

    return str
  }
}
